import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../../src/styles/index.css";
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
import HfrRegisterOTP from "../components/HfrRegister/CreateHealthOTP";
import HfrLogin from "../components/hfrlogin/LoginHfr";

function HfrRegisterOTPs() {
  const [tabs, setTabs] = useState(0);

  useEffect(() => {
    localStorage.setItem("myPath", window.location.pathname);
  }, []);

  return (
    <>
      <div className='mx-auto w-11/12 bg-white'>
        <div className='flex justify-center gap-[1rem] border-b border-gray-200 text-2xl'>
          {["Login", "Register Facility"].map((item, index) => (
            <span
              key={index}
              onClick={() => setTabs(index)}
              className={`cursor-pointer px-[5rem] py-[1rem] text-center ${tabs === index ? "border-b-4 border-[#0097DB] text-[#0097DB]" : "text-gray-500"} px-4 py-2`}
            >
              {item}
            </span>
          ))}
        </div>
        {tabs === 0 ? <HfrLogin /> : <HfrRegisterOTP />}
      </div>
    </>
  );
}

export default HfrRegisterOTPs;
